module.exports = __webpack_public_path__ + "img/special_tinyGalaxy.86295f3e.png";